export const MODELS = [
  "claude-3-5-sonnet",
  "claude-3-haiku",
  "claude-3-sonnet",
] as const;

export type Model = (typeof MODELS)[number];
export function isModel(model: string): model is Model {
  return MODELS.includes(model as Model);
}
